/** Port des `NotFound`-Zweigs aus `App.razor`. */

import type { ReactElement } from 'react';
import { useEffect } from 'react';

export function NotFound(): ReactElement {
  // Pendant zu `<PageTitle>Not found</PageTitle>`.
  useEffect(() => {
    document.title = 'Not found';
  }, []);

  return <p role="alert">Sorry, there&apos;s nothing at this address.</p>;
}

export default NotFound;
